import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateIglooDevices } from './get-igloo-devices'
import { useInvalidateIglooPin } from './get-igloo-pin'

const createIglooUser = async (clientId: string) => {
  const response = await authAPI.post('/igloowork/users', { clientId })
  return response.data
}

export const useCreateIglooUser = (clientId: string) => {
  const invalidateDevices = useInvalidateIglooDevices(clientId)
  const invalidatePin = useInvalidateIglooPin(clientId)
  return useMutation({
    mutationFn: () => createIglooUser(clientId),
    onSuccess: () => {
      invalidateDevices()
      invalidatePin()
    },
  })
}
